import QaAssetVideo from "./qa-asset-video.model";
import QaAsset from "./qa-asset.model";

export default function isAssetVideo(
  qaAsset: QaAsset
): qaAsset is QaAssetVideo {
  return qaAsset instanceof QaAssetVideo;
}
